import { useEffect } from 'react'
import { useLocation } from 'react-router'
import AppRouteNames from '../../constants/route'

const SELF_MANAGED_SCROLL_PATHS = [AppRouteNames.home]

const ScrollToTop = () => {
	const { pathname } = useLocation()

	useEffect(() => {
		if (SELF_MANAGED_SCROLL_PATHS.includes(pathname)) {
			return
		}
		window.scrollTo(0, 0)
	}, [pathname])

	return null
}

export default ScrollToTop
